import React from "react";
import { Card, Row, Col, Radio, Input, Tag, DatePicker, Form } from "antd";
import dayjs from "dayjs";



function PrivateLandForm({ form, stepKey, tracking }) {
  const sectionDateMap = {
    private_1: tracking?.section1_planned_date,
    private_2: tracking?.section2_planned_date,
    private_3: tracking?.section3_planned_date,
    private_4: tracking?.section4_planned_date,
  };

  const renderSectionTitle = (title) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <span>{title}</span>
      {sectionDateMap[stepKey] && (
        <Tag color="blue">
          Planned: {dayjs(sectionDateMap[stepKey]).format("DD MMM YYYY")}
        </Tag>
      )}
    </div>
  );

  // ── STEP 1: Land Demand & Type ─────────────────────────────────────────────
  if (stepKey === "private_1") {
    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("LAND DEMAND & TYPE")}>
          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Whether Govt. Land available?</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24}>
                <Form.Item name="whether_govt_land_available_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                    <Radio value="PENDING">Pending</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Whether MIDC land available?</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24}>
                <Form.Item name="whether_midc_land_available_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                    <Radio value="PENDING">Pending</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Card>
      </Form>
    );
  }

  // ── STEP 2: Private Land Initiation ───────────────────────────────────────
  if (stepKey === "private_2") {
    const config = [
      {
        label: "Proposal for Private Land Permission submitted to Corporate Office?",
        fields: [
          { name: "proposal_for_private_land_permission_submitted_to_corporate_office_status", label: "Status", type: "radio", md: 4 },
          { name: "proposal_for_private_land_permission_submitted_to_corporate_office_date_planned", label: "Date Planned", type: "date", md: 4 },
          { name: "proposal_for_private_land_permission_submitted_to_corporate_office_date_actual", label: "Date Actual", type: "date", md: 4 },
          { name: "proposal_for_private_land_permission_submitted_to_corporate_office_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Whether Hon. CMD In-Principle Approval received for acquisition of Private Land?",
        fields: [
          { name: "whether_hon_cmd_in_principle_approval_received_for_acquisition_of_private_land_status", label: "Status", type: "radio", md: 4 },
          { name: "whether_hon_cmd_in_principle_approval_received_for_acquisition_of_private_land_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "whether_hon_cmd_in_principle_approval_received_for_acquisition_of_private_land_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Expression of Interest (EOI) published in newspapers?",
        fields: [
          { name: "expression_of_interest_(eoi)_published_in_newspapers_status", label: "Status", type: "radio", md: 4 },
          { name: "expression_of_interest_(eoi)_published_in_newspapers_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "expression_of_interest_(eoi)_published_in_newspapers_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      }
    ];

    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("PRIVATE LAND INITIATION")}>
          {config.map((item, idx) => (
            <Card key={idx} className="tracking-item-card">
              <h4 className="tracking-question-label">{item.label}</h4>
              <Row gutter={[16, 12]}>
                {item.fields.map((f) => (
                  <Col xs={24} md={f.md} key={f.name}>
                    <Form.Item name={f.name} label={f.label}>
                      {f.type === "radio" && (
                        <Radio.Group>
                          <Radio value="YES">Yes</Radio>
                          <Radio value="NO">No</Radio>
                          <Radio value="PENDING">Pending</Radio>
                        </Radio.Group>
                      )}
                      {f.type === "date" && <DatePicker style={{ width: "100%" }} />}
                      {f.type === "input" && <Input />}
                    </Form.Item>
                  </Col>
                ))}
              </Row>
            </Card>
          ))}
        </Card>
      </Form>
    );
  }

  // ── STEP 3: Land Selection ─────────────────────────────────────────────────
  if (stepKey === "private_3") {
    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("LAND SELECTION")}>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Whether Feasibility ascertainment done (Electrical)</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={4}>
                <Form.Item name="whether_feasibility_ascertainment_done_(electrical)_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                    <Radio value="PENDING">Pending</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="whether_feasibility_ascertainment_done_(electrical)_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="whether_feasibility_ascertainment_done_(electrical)_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Whether Feasibility ascertainment done (Civil)</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={4}>
                <Form.Item name="whether_feasibility_ascertainment_done_(civil)_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                    <Radio value="PENDING">Pending</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="whether_feasibility_ascertainment_done_(civil)_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="whether_feasibility_ascertainment_done_(civil)_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Most feasible land parcel identified & ranked</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={4}>
                <Form.Item name="most_feasible_land_parcel_identified_ranked_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                    <Radio value="PENDING">Pending</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="most_feasible_land_parcel_identified_ranked_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="most_feasible_land_parcel_identified_ranked_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Distance of most feasible land from load centre (km)</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={8}>
                <Form.Item name="distance_of_most_feasible_land_from_load_centre_(km)_distance" label="Distance (km)">
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={16}>
                <Form.Item name="distance_of_most_feasible_land_from_load_centre_(km)_remarks" label="Remarks">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Details of Feasible Land</h4>

            <Row gutter={[16, 12]}>
              <Col xs={24} md={12}>
                <Form.Item name="mouje_details" label="MOUJE">
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="taluka_name" label="TALUKA">
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 12]}>
              <Col xs={24} md={12}>
                <Form.Item name="district_name" label="DISTRICT">
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="surveyno/gutno_details" label="SURVEY NO / GUT NO">
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 12]}>
              <Col xs={24}>
                <Form.Item name="details_of_feasible_land_remarks" label="REMARKS">
                  <Input.TextArea rows={4} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

        </Card>
      </Form>
    );
  }

  // ── STEP 4: Land Verification ─────────────────────────────────────────────
  if (stepKey === "private_4") {
    const config = [
      {
        label: "Land Owner(s) agreed to the negotiated rate (consent letter obtained)?",
        fields: [
          { name: "land_owner(s)_agreed_to_the_negotiated_rate_(consent_letter_obtained)_status", label: "Status", type: "radio", md: 4 },
          { name: "land_owner(s)_agreed_to_the_negotiated_rate_(consent_letter_obtained)_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "land_owner(s)_agreed_to_the_negotiated_rate_(consent_letter_obtained)_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Legal search / title verification / encumbrance check completed",
        fields: [
          { name: "legal_search_title_verification_encumbrance_check_completed_status", label: "Status", type: "radio", md: 4 },
          { name: "legal_search_title_verification_encumbrance_check_completed_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "legal_search_title_verification_encumbrance_check_completed_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Proposal submitted to Collector office for rate finalization via Negotiation Committee",
        fields: [
          { name: "proposal_submitted_to_collector_office_for_rate_finalization_via_negotiation_committee_status", label: "Status", type: "radio", md: 4 },
          { name: "proposal_submitted_to_collector_office_for_rate_finalization_via_negotiation_committee_date_planned", label: "Date Planned", type: "date", md: 4 },
          { name: "proposal_submitted_to_collector_office_for_rate_finalization_via_negotiation_committee_date_actual", label: "Date Actual", type: "date", md: 4 },
          { name: "proposal_submitted_to_collector_office_for_rate_finalization_via_negotiation_committee_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Negotiation Committee meeting held & rates finalized",
        fields: [
          { name: "negotiation_committee_meeting_held_rates_finalized_status", label: "Status", type: "radio", md: 4 },
          { name: "negotiation_committee_meeting_held_rates_finalized_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "negotiation_committee_meeting_held_rates_finalized_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Final proposal submitted to Competent Authority (MSETCL) for approval",
        fields: [
          { name: "final_proposal_submitted_to_competent_authority_(msetcl)_for_approval_status", label: "Status", type: "radio", md: 4 },
          { name: "final_proposal_submitted_to_competent_authority_(msetcl)_for_approval_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "final_proposal_submitted_to_competent_authority_(msetcl)_for_approval_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Final approval received from Competent Authority (MSETCL)",
        fields: [
          { name: "final_approval_received_from_competent_authority_(msetcl)_status", label: "Status", type: "radio", md: 4 },
          { name: "final_approval_received_from_competent_authority_(msetcl)_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "final_approval_received_from_competent_authority_(msetcl)_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Final notice published in approved newspapers",
        fields: [
          { name: "final_notice_published_in_approved_newspapers_(date_name_of_papers)_status", label: "Status", type: "radio", md: 4 },
          { name: "final_notice_published_in_approved_newspapers_(date_name_of_papers)_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "final_notice_published_in_approved_newspapers_(date_name_of_papers)_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Joint Measurement (JM) scheduled with Revenue Authorities",
        fields: [
          { name: "joint_measurement_(jm)_scheduled_with_revenue_authorities_status", label: "Status", type: "radio", md: 4 },
          { name: "joint_measurement_(jm)_scheduled_with_revenue_authorities_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "joint_measurement_(jm)_scheduled_with_revenue_authorities_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "JM carried out / JM plan / report received & verified",
        fields: [
          { name: "jm_carried_out_jm_plan_report_received_verified_status", label: "Status", type: "radio", md: 4 },
          { name: "jm_carried_out_jm_plan_report_received_verified_date_planned", label: "Date Planned", type: "date", md: 4 },
          { name: "jm_carried_out_jm_plan_report_received_verified_date_actual", label: "Date Actual", type: "date", md: 4 },
          { name: "jm_carried_out_jm_plan_report_received_verified_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Stamp duty & registration charges paid",
        fields: [
          { name: "stamp_duty_registration_charges_paid_status", label: "Status", type: "radio", md: 4 },
          { name: "stamp_duty_registration_charges_paid_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "stamp_duty_registration_charges_paid_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Sale deed / Lease deed / Transfer deed registered at Sub-Registrar Office",
        fields: [
          { name: "sale_deed_lease_deed_transfer_deed_registered_at_sub_registrar_office_status", label: "Status", type: "radio", md: 4 },
          { name: "sale_deed_lease_deed_transfer_deed_registered_at_sub_registrar_office_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "sale_deed_lease_deed_transfer_deed_registered_at_sub_registrar_office_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      },
      {
        label: "Registration number & date recorded",
        fields: [
          { name: "registration_number_date_recorded_status", label: "Status", type: "radio", md: 6 },
          { name: "registration_number_date_recorded_remarks", label: "Remarks", type: "input", md: 18 }
        ]
      },
      {
        label: "Final possession taken",
        fields: [
          { name: "final_possession_taken_status", label: "Status", type: "radio", md: 4 },
          { name: "final_possession_taken_date_actual", label: "Date Actual", type: "date", md: 8 },
          { name: "final_possession_taken_remarks", label: "Remarks", type: "input", md: 24 }
        ]
      }
    ];

    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("LAND VERIFICATION")}>
          {config.map((item, idx) => (
            <Card key={idx} className="tracking-item-card">
              <h4 className="tracking-question-label">{item.label}</h4>
              <Row gutter={[16, 12]}>
                {item.fields.map((f) => (
                  <Col xs={24} md={f.md} key={f.name}>
                    <Form.Item name={f.name} label={f.label}>
                      {f.type === "radio" && (
                        <Radio.Group>
                          <Radio value="YES">Yes</Radio>
                          <Radio value="NO">No</Radio>
                          <Radio value="PENDING">Pending</Radio>
                        </Radio.Group>
                      )}
                      {f.type === "date" && <DatePicker style={{ width: "100%" }} />}
                      {f.type === "input" && <Input />}
                    </Form.Item>
                  </Col>
                ))}
              </Row>
            </Card>
          ))}
        </Card>
      </Form>
    );
  }

  return null;
}

export default PrivateLandForm;